import React from "react";
import classNames from "classnames";
import withStyles from "react-jss";

const styles = (theme) => ({
	root: {
		display: "flex",
		flexDirection: "column",
		justifyContent: "center",
		alignItems: "center",
		height: "100%",
	},
	header: {
		fontSize: "24px",
		fontFamily: theme.fonts.bold,
		color: theme.palette.colors.paleGrey,
		lineHeight: 1.2,
		textAlign: "center",
		marginBottom: "22px",
	},
	text: {
		fontSize: "16px",
		fontFamily: theme.fonts.light,
		color: theme.palette.colors.paleGrey,
		lineHeight: 1.2,
		textAlign: "center",
	},
	textMedium: {
		fontFamily: theme.fonts.medium,
	},
	isDark: {
		"& $header": {
			color: theme.palette.colors.darkSlateBlue,
		},
		"& $text": {
			color: theme.palette.colors.oneMoreGrey,
		},
	},
	[`@media (max-width: ${theme.media.md})`]: {
		header: {
			fontSize: "18px",
		},
	},
});

class Welcome extends React.PureComponent {
	static defaultProps = {
		title: "",
		text: "",
	};

	render() {
		let classes = this.props.classes;

		return (
			<div
				className={classNames(classes.root, {
					[classes.isDark]: this.props.dark,
				})}
			>
				<div className={classes.header}> {this.props.title}</div>
				<div
					className={classNames(classes.text, {
						[classes.textMedium]: this.props.textMedium,
					})}
				>
					{this.props.text}
				</div>
			</div>
		);
	}
}

export default withStyles(styles)(Welcome);
